"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferHotspotV1 = exports.RewardsV2 = exports.RewardsV1 = exports.UnknownTransaction = exports.PaymentV2 = exports.PaymentV1 = exports.AssertLocationV2 = exports.AssertLocationV1 = exports.TokenBurnV1 = exports.AddGatewayV1 = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable max-classes-per-file */
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const currency_1 = require("@helium/currency");
const Challenge_1 = __importDefault(require("./Challenge"));
const DataModel_1 = __importDefault(require("./DataModel"));
class AddGatewayV1 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.AddGatewayV1 = AddGatewayV1;
class TokenBurnV1 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.TokenBurnV1 = TokenBurnV1;
class AssertLocationV1 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.AssertLocationV1 = AssertLocationV1;
class AssertLocationV2 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.AssertLocationV2 = AssertLocationV2;
class PaymentV1 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.PaymentV1 = PaymentV1;
class PaymentV2 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.PaymentV2 = PaymentV2;
class UnknownTransaction extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.UnknownTransaction = UnknownTransaction;
class RewardsV1 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.RewardsV1 = RewardsV1;
class RewardsV2 extends RewardsV1 {
}
exports.RewardsV2 = RewardsV2;
function prepareTxn(txn) {
    if (txn.fee && typeof txn.fee === 'number') {
        txn.fee = new currency_1.Balance(txn.fee, currency_1.CurrencyType.dataCredit);
    }
    if (txn.staking_fee && typeof txn.staking_fee === 'number') {
        txn.staking_fee = new currency_1.Balance(txn.staking_fee, currency_1.CurrencyType.dataCredit);
    }
    if (txn.amount && typeof txn.amount === 'number') {
        txn.amount = new currency_1.Balance(txn.amount, currency_1.CurrencyType.networkToken);
    }
    if (txn.total_amount && typeof txn.total_amount === 'number') {
        txn.total_amount = new currency_1.Balance(txn.total_amount, currency_1.CurrencyType.networkToken);
    }
    if (txn.amount_to_seller && typeof txn.amount_to_seller === 'number') {
        txn.amount_to_seller = new currency_1.Balance(txn.amount_to_seller, currency_1.CurrencyType.networkToken);
    }
    return camelcase_keys_1.default(txn);
}
class TransferHotspotV1 extends DataModel_1.default {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.TransferHotspotV1 = TransferHotspotV1;
class Transaction {
    static fromJsonObject(json) {
        switch (json.type) {
            case 'payment_v1':
                return this.toPaymentV1(json);
            case 'payment_v2':
                return this.toPaymentV2(json);
            case 'add_gateway_v1':
                return this.toAddGatewayV1(json);
            case 'rewards_v1':
                return this.toRewardsV1(json);
            case 'rewards_v2':
                return this.toRewardsV2(json);
            case 'poc_receipts_v1':
                return this.toPocReceiptsV1(json);
            case 'transfer_hotspot_v1':
                return this.toTransferHotspotV1(json);
            case 'assert_location_v1':
                return this.toAssertLocationV1(json);
            case 'assert_location_v2':
                return this.toAssertLocationV2(json);
            case 'token_burn_v1':
                return this.toTokenBurnV1(json);
            default:
                return this.toUnknownTransaction(json);
        }
    }
    static toPaymentV1(json) {
        return new PaymentV1(prepareTxn(json));
    }
    static toPaymentV2(json) {
        const payments = (json.payments || []).map((p) => (Object.assign(Object.assign({}, p), { amount: new currency_1.Balance(p.amount, currency_1.CurrencyType.default) })));
        const sumAmount = (json.payments || []).reduce((sum, { amount }) => sum + amount, 0);
        const totalAmount = new currency_1.Balance(sumAmount, currency_1.CurrencyType.default);
        return new PaymentV2(prepareTxn(Object.assign(Object.assign({}, json), { payments,
            totalAmount })));
    }
    static toAddGatewayV1(json) {
        return new AddGatewayV1(prepareTxn(json));
    }
    static toAssertLocationV1(json) {
        return new AssertLocationV1(prepareTxn(json));
    }
    static toAssertLocationV2(json) {
        return new AssertLocationV2(prepareTxn(json));
    }
    static toTokenBurnV1(json) {
        return new TokenBurnV1(prepareTxn(json));
    }
    static toUnknownTransaction(json) {
        return new UnknownTransaction(prepareTxn(json));
    }
    static toPocReceiptsV1(json) {
        return new Challenge_1.default(json);
    }
    static toTransferHotspotV1(json) {
        return new TransferHotspotV1(prepareTxn(json));
    }
    static toRewardsV1(json) {
        const rewards = (json.rewards || []).map((r) => (Object.assign(Object.assign({}, r), { amount: new currency_1.Balance(r.amount, currency_1.CurrencyType.default) })));
        const sumAmount = (json.rewards || []).reduce((sum, { amount }) => sum + amount, 0);
        const totalAmount = new currency_1.Balance(sumAmount, currency_1.CurrencyType.default);
        return new RewardsV1(prepareTxn(Object.assign(Object.assign({}, json), { rewards,
            totalAmount })));
    }
    static toRewardsV2(json) {
        return this.toRewardsV1(json);
    }
}
exports.default = Transaction;
//# sourceMappingURL=Transaction.js.map